import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PageContainer from '../PageContainer/PageContainer';
import styles from 'assets/jss/material-dashboard-pro-react/components/alertBarStyle';
import Alerts from './Alerts';
import { AlertsAndNotificationsService } from 'services/alertsAndNotifications/alertsAndNotifications';
import { Alerts as IAlerts } from 'utils/api/models/alertsAndNotifications/alertsAndNotifications';
import { getLanguage } from 'utils/language/language';
import { getNotificationsLabels } from 'redux/modules/dynamicLabels/selectors';
import { useSelector } from 'react-redux';
import flatten from 'lodash/flatten';

// @ts-ignore
const useStyles = makeStyles(styles);

const AlertBar: React.FC = () => {
	const classes = useStyles();
	const [alerts, setAlerts] = useState<IAlerts[]>([]);
	const lang = getLanguage();
	const alertConfig = useSelector(getNotificationsLabels);
	const limit = alertConfig?.alert_limit || 1;

	useEffect(() => {
		AlertsAndNotificationsService.getAlerts()
			.pipe()
			.subscribe((res: any) => {
				const visibleAlerts: IAlerts[] = flatten(
					res?.response?.content?.length
						? res?.response?.content
								.slice(0, limit)
								.map((alert: any) =>
									alert.templates
										? alert.templates.filter((item: any) => item.language === lang.toUpperCase())
										: []
								)
						: []
				);
				setAlerts(visibleAlerts);
			});
	}, [lang]);

	return (
		<>
			{alerts && alerts.length > 0 && (
				<section className={classes.alertBarSection}>
					<PageContainer>
						{alerts.map((alert) => (
							<Alerts description={alert.message} key={alert.title} />
						))}
					</PageContainer>
				</section>
			)}
		</>
	);
};

export default AlertBar;
